import {FrontWebSongModel} from "../../../generated";
import ListCss from "../List.module.scss";
import { SongRow} from "../../Item/Song/SongRow";


export const SongRowList = (props: {
    items: FrontWebSongModel[],
    twoItemsPerRow?: boolean,
    twoItemsPerRowMain?: boolean
    className?: string
}) => {
    const twoItemClass = (()=>{
        if (props.twoItemsPerRowMain) {
            return ListCss.TwoItemMain;
        }
        else if (props.twoItemsPerRow) {
            return ListCss.TwoItem;
        }
        return "";
    })();

    return <ul className={`d-flex align-justify-start flex-wrap ${ListCss.UlRow} ${props.className ?? ""}`}>
        {props.items.map((item, k) => (
            <li key={k} className={`flex-fill ${twoItemClass}`}>
                <SongRow multiple={props.twoItemsPerRow || props.twoItemsPerRowMain} song={item} className={"mb-4"}/>
            </li>)
        )}</ul>
}

